import {
    Box,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Paper,
    Tooltip,
    Typography
} from '@mui/material';
import {Check, Star, Tv} from '@mui/icons-material';
import UserAvatar from '../UserAvatar';

export default function PlayerList({ players, gameMasterId, gameMasterParticipates }) {
  const playerCount = Object.keys(players || {}).length;

  const handleProfileClick = (player) => {
    if (player.profilePath) {
      window.open(`/profil/${player.profilePath}`, '_blank');
    }
  };

  // Sortiere die Spieler: Game Master zuerst, dann nach uid
  const sortedPlayers = Object.entries(players || {}).sort(([idA, ], [idB, ]) => {
    // Game Master immer zuerst
    if (idA === gameMasterId) return -1;
    if (idB === gameMasterId) return 1;
    
    // Andere Spieler nach uid sortieren
    return idA.localeCompare(idB);
  });

  return (
    <Paper className="glass player-list">
      <Box className="box-header">
        <Typography variant="h6">
          {playerCount} Spieler
        </Typography>
      </Box>

      <Box className="box-divider" />

      <Box className="box-content player-list">
        <List>
          {sortedPlayers.map(([playerId, player]) => {
            const hasProfile = !!player.profilePath;
            const isGameMaster = playerId === gameMasterId;
            
            return (
              <ListItem
                key={playerId}
                className={player.isReady ? 'ready' : ''}
              >
                <ListItemAvatar>
                  <UserAvatar 
                    src={player.hasRpmAvatar ? player.rpmModelUrl?.replace('.glb', '.png') : player.photoURL}
                    alt={player.displayName}
                    size={40}
                    hasRpmAvatar={Boolean(player.hasRpmAvatar)}
                    rpmModelUrl={player.rpmModelUrl}
                  />
                </ListItemAvatar>
                <ListItemText 
                  primary={
                    <Box className="player-name-container">
                      {hasProfile ? (
                        <Link
                          component="button"
                          variant="subtitle1"
                          className="player-name"
                          onClick={() => handleProfileClick(player)}
                          sx={{
                            textAlign: 'left',
                            textDecoration: 'none',
                            '&:hover': {
                              textDecoration: 'underline',
                              color: 'var(--color-secondary)'
                            }
                          }}
                        >
                          {player.displayName}
                        </Link>
                      ) : (
                        <Typography
                          variant="subtitle1" 
                          className="player-name"
                        >
                          {player.displayName}
                        </Typography>
                      )}
                      {isGameMaster && (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Tooltip 
                            title="Game Master"
                            placement="top"
                          >
                            <IconButton 
                              size="small" 
                              disableRipple 
                              className="icon-button-transparent"
                            >
                              <Star className="game-master-icon" />
                            </IconButton>
                          </Tooltip>
                          {isGameMaster && !gameMasterParticipates && (
                            <Tooltip 
                              title="Presenter-Modus"
                              placement="top"
                            >
                              <IconButton 
                                size="small" 
                                disableRipple 
                                className="icon-button-transparent"
                              >
                                <Tv sx={{ 
                                  color: '#ffc107', 
                                  fontSize: '20px'
                                }} />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      )}
                    </Box>
                  }
                />
                {player.isReady && (
                  <Check className="ready-icon" />
                )}
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Paper>
  );
} 